module.exports = __webpack_public_path__ + "static/media/S1N11.bc300f67.svg";